import { z } from "zod";

/**
 * Call flow configuration
 */
export const PhoneCallFlowSchema = z.object({
  user_start_first: z.boolean(),
  interruption: z.object({
    allowed: z.boolean(),
    keep_interruption_message: z.boolean()
  }),
  response_delay: z.number(),
  auto_fill_responses: z
    .object({
      messages: z.array(z.string()),
      response_gap_threshold: z.number()
    })
    .optional()
});

export type PhoneCallFlow = z.infer<typeof PhoneCallFlowSchema>;
